<template>
  <section
    class="partner"
    v-if="logo_list.length > 0"
    :style="{ 'max-width': maxWidth + 'px' }"
  >
    <img
      v-for="(item, index) in logo_list"
      :key="index"
      :src="item"
      alt=""
      class="logo_item"
    />
  </section>
</template>
<script>
export default {
  props: {
    logo_list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    maxWidth: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Number | String,
      default: 1100,
    },
  },
};
</script>
<style lang="less" scoped>
.partner {
  background: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin: auto;
  .logo_item {
    height: 20px;
    width: auto;
  }
}
</style>
